/*
 * @Author: LZT
 * @Date: 2024-12-11 11:14:08
 * @LastEditors: ITDLCL
 * @Description:
 * @FilePath: \qs\src\router\index.js
 */
import { createRouter, createWebHashHistory } from "vue-router";
import { isTestAccount } from "@/utils";

/** 原始静态路由（未做任何处理） */
const routes = [];
const modules = import.meta.glob(
  ["./modules/**/*.js", "!./modules/**/remaining.js"],
  { eager: true }
);
Object.keys(modules).forEach(key => {
  routes.push(...modules[key].default);
});
const router = createRouter({
  history: createWebHashHistory(),
  routes,
  // 跳转页面，重置页面锚点，返回页面，记录原页面锚点
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  isTestAccount();

  // 检查路由参数中是否包含code和state
  const { code, state, ...otherParams } = to.query;
  // 如果存在code或state参数，且wechat_auth_state不存在  说明code和state已经用过了， 所以去掉code state参数
  if (code && state && !localStorage.getItem("wechat_auth_state")) {
    const newQuery = { ...otherParams };
    next({
      path: to.path,
      query: newQuery,
      replace: true
    });
    return;
  }

  next();
});

export default router;

